export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"A news site developed with Nuxt."}],"link":[],"style":[],"script":[],"noscript":[],"title":"The Daily Broadcast","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/news-site-nuxt-static/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const devPagesDir = null

export const devRootDir = null